import { render, staticRenderFns } from "./ModalSendMail.vue?vue&type=template&id=039201fd&scoped=true"
import script from "./ModalSendMail.vue?vue&type=script&lang=js"
export * from "./ModalSendMail.vue?vue&type=script&lang=js"
import style0 from "./ModalSendMail.vue?vue&type=style&index=0&id=039201fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039201fd",
  null
  
)

export default component.exports